import style from './LuckyCardListItem.css';
import useConfig from '../../../config/config.context';
import { _className } from '../../../utils/classname.utils';
import { renderIf } from '../../../utils/render.utils';
import FormatterUtils from '../../../utils/formatter.utils';
import ChevronRightSmallIcon from '../../shared/Icons/ChevronRightSmallIcon';
import CardStatus from '../../../constants/card.status';
import CardThumbnail from '../../shared/CardThumbnail/CardThumbnail';
import CardMessage from '../../Wallet/CardStatus/CardMessage';
import useTranslation from '../../../localization/i18n.context';
import CaasStorageKeys from '../../../constants/caas.storage.keys';
import CreditStatus from '../../../constants/credit.status';

export default function LuckyCardListItem({
  className = '',
  card,
  onClick,
  lendingButtonEnabled = false,
}) {
  const { config } = useConfig();
  const { t, getOrganization, getCurrency } = useTranslation();
  const organizationName = getOrganization(card.organizationCode);
  const shouldRenderCredit =
    lendingButtonEnabled &&
    card?.credit &&
    (card.credit.status === CreditStatus.ACTIVE ||
      card.credit.status === CreditStatus.USED);
  return (
    <div className={`${className} ${style['card-row']}`} data-testid="card">
      <div className={style.container} onClick={onClick}>
        <div className={style.content}>
          <span className={style.organization} data-testid="card-organization">
            {organizationName}
          </span>
          <span
            className={`${style.balance} ${_className(
              !config[CaasStorageKeys.STORAGE].showBalance,
              'text-blur',
            )}`}
            data-testid="card-balance"
          >
            {FormatterUtils.currency(card.balance, getCurrency(card.currency))
              .split(' ')
              .map(el => {
                return <span> {el}</span>;
              })}
          </span>
          {renderIf(
            card.showInfoLine !== false,
            <span className={style.number}>
              {renderIf(
                card.number != null,
                <span>
                  <span data-testid="card-number">
                    {FormatterUtils.cardNumber(card.number)}
                  </span>
                  {renderIf(
                    shouldRenderCredit,
                    <span>
                      <span className={style.dots}>·</span>
                      <span className={style.credit}>{`${t(
                        'Credit limit',
                      )} ${FormatterUtils.currency(
                        card.credit?.availableAmount,
                        getCurrency(card.credit?.currency),
                      )}`}</span>
                    </span>,
                  )}
                </span>,
              )}
              {renderIf(
                card.status === CardStatus.LOCKED,
                <span className={style.locked} data-testid="card-info">
                  {card.status}
                </span>,
              )}
            </span>,
          )}
        </div>
        <div className={style.icon}>
          <ChevronRightSmallIcon
            className={`${style['forward-icon']}`}
            width={12}
            height={12}
          />
        </div>
        <span className={style.thumbnail}>
          <CardThumbnail organization={card.organizationCode} />
        </span>
      </div>
      <div className={style.message}>
        <CardMessage
          status={card.status}
          cardUid={card.uid}
          credit={card?.credit}
          size={CardMessage.Size.COMPACT}
          isHome={true}
          organization={card.organizationCode}
          cardNumber={card.number}
          lendingButtonEnabled={lendingButtonEnabled}
          isPersonalizedCard={card?.personalizedCardEnabled}
          automaticLendingEnabled={card?.automaticLendingEnabled}
        />
      </div>
    </div>
  );
}
